import type React from 'react';
import type { ImgHTMLAttributes } from 'react';

const toSameOriginImagePath = (src?: string): string | undefined => {
  if (!src?.trim()) return undefined;
  if (src.startsWith('http://') || src.startsWith('https://')) return src;
  if (src.startsWith('/v1/')) return src;
  return `/v1${src.startsWith('/') ? src : `/${src}`}`;
};

export const Image: React.FC<ImgHTMLAttributes<HTMLImageElement>> = ({
  src,
  ...props
}) => {
  const resolved = toSameOriginImagePath(src);
  if (!resolved) return null;
  return <img src={resolved} {...props} />;
};
